import { render, staticRenderFns } from "./PayItemDrawer.vue?vue&type=template&id=31c5d767&scoped=true"
import script from "./PayItemDrawer.vue?vue&type=script&lang=js"
export * from "./PayItemDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c5d767",
  null
  
)

export default component.exports